import { LEGACY_PLATFORM_BASE_URL } from "../constants";
import { initialized } from "../utils/initializedUtil";
import FormService from "./FormService";
import { useAuthState } from "../state/auth";
import type CustomerId from "../state/CustomerId";

type FormVersionSavedPayload = {
  type: "formVersionSaved";
  formVersionId: string;
};

type FormVersionPublishedPayload = {
  type: "formVersionPublished";
  formVersionId: string;
};

let customerId: CustomerId | null = null;
let parentWindow: Window | null = null;

const init = (cusId: CustomerId) => {
  customerId = cusId;
  parentWindow = window.opener;
};

const getCustomerId = () => initialized(customerId, "formVersionStore");

const postMessage = (payload: FormVersionSavedPayload | FormVersionPublishedPayload) => {
  parentWindow?.postMessage(payload, `${LEGACY_PLATFORM_BASE_URL}/customers/${getCustomerId()}/form/overview`);
};

const notifySaved = () =>
  postMessage({
    type: "formVersionSaved",
    formVersionId: FormService.getFormVersionId().toString(),
  });

const notifyPublished = () =>
  postMessage({
    type: "formVersionPublished",
    formVersionId: FormService.getFormVersionId().toString(),
  });

const createLegacyPlatformOverviewUrl = (customerId: CustomerId): string => {
  const { impersonation } = useAuthState();

  // Prefer impersonation over supplied customer id
  if (impersonation()?.type === "customer") {
    return `${LEGACY_PLATFORM_BASE_URL}/admin?customer=${impersonation()?.value.toString()}`;
  } else {
    return `${LEGACY_PLATFORM_BASE_URL}/customers/${customerId}`;
  }
};

const LegacyPlatformService = {
  notifySaved,
  notifyPublished,
  createLegacyPlatformOverviewUrl,
  init,
};

export default LegacyPlatformService;
